/* esm.sh - zod@4.4.3/v4/locales */
export * from "/*zod@4.4.3/esnext/v4/locales.mjs";
